import Button from "@mui/material/Button"
import { toast } from "react-toastify"

const export_data = (geo_json, file_name, format) => {
  const geo_json_properties = (geojson) => {
    let properties = []
    geojson.features.forEach((feature) => {
      Object.keys(feature.properties).forEach((key) => {
        if (!properties.includes(key)) {
          properties.push(key)
        }
      })
    })
    return properties
  }

  const to_csv = (geo_json) => {
    let result_string = ""
    const geo_properties = geo_json_properties(geo_json)
    result_string += geo_properties.join(",") + "\n"

    geo_json.features.forEach((feature) => {
      let row = []
      geo_properties.forEach((property) => {
        if (property in feature.properties) {
          if (Array.isArray(feature.properties[property])) {
            row.push(`"${feature.properties[property]}"`)
          } else {
            row.push(feature.properties[property])
          }
        } else {
          row.push("NA")
        }
      })

      result_string += row.join(",") + "\n"
    })
    return result_string
  }

  try {
    if (!geo_json) {
      toast.error("No data to export")
      return null
    }
    const data = format === "json" ? JSON.stringify(geo_json) : to_csv(geo_json)
    var a = document.createElement("a")
    var file = new Blob([data], { type: "text/plain" })
    a.href = URL.createObjectURL(file)
    a.download = `${file_name}.${format}`
    a.click()
  } catch (error) {
    console.log(error)
  }
}

export default function Export({ map_data }) {
  const { au_geo_json, fac_geo_json, cup_geo_json, cup_boundary_geo_json } =
    map_data
  return (
    <div>
      <Button
        fullWidth
        onClick={() => {
          export_data(au_geo_json, "analysis_units", "json")
        }}
      >
        Analysis Units
      </Button>
      <Button
        fullWidth
        onClick={() => {
          export_data(fac_geo_json, "facilities", "json")
        }}
      >
        Facilities
      </Button>
      <Button
        fullWidth
        onClick={() => {
          export_data(cup_geo_json, "cup_points", "json")
        }}
      >
        CUP Points
      </Button>
      <Button
        fullWidth
        onClick={() => {
          export_data(cup_boundary_geo_json, "cup_boundaries", "json")
        }}
      >
        CUP Boundary
      </Button>
    </div>
  )
}
